module.exports = __webpack_public_path__ + "static/media/Annatel-logo_RGB-1.ac1a3162.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Annatel-logo_RGB-1.png
// module id = 614
// module chunks = 0